import React from "react";

import { FpsContext } from "../../components/FpsProvider";

/**
 * Hook to access the FpsContext value.
 *
 * @returns The FpsContext value.
 * @throws Will throw an error if used outside of a FpsContext provider.
 * @example
 * const fps = useFps();
 */
function useFps() {
  const fps = React.useContext(FpsContext);

  if (fps === undefined) {
    throw new Error("useFps must be used within a FpsContext provider.");
  }

  return fps;
}

export default useFps;
